
{
  "familyId": "SPR-WEET-EI-IJ",
  "questions": [
    {
      "id": "SPR-WEET-EI-IJ-001",
      "familyId": "SPR-WEET-EI-IJ",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_ei_ij",
      "questionType": "multiple_choice",
      "question": "Welke spelling is juist?",
      "context": null,
      "options": ["sympathiek", "sympatiek", "simpatiek", "symphatiek"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Weetwoorden", "content": "Dit is een weetwoord: je moet uit je hoofd weten dat het 'sympathiek' is (met y en th). Dit komt uit het Grieks. Andere Griekse woorden: fysiek, psychologie, theater.", "icon": "book" }, "showWhen": "wrong" }],
      "conceptId": "irregular_spelling_word",
      "variantIndex": 1,
      "feedback": { "explanationText": "Dit is een Grieks leenwoord: sympathiek (met y en th). Je moet dit uit je hoofd leren - het is een weetwoord.", "distractorExplanations": { "0": "Correct! Grieks leenwoord met y en th: sympathiek.", "1": "Fout: je vergeet de 'h' in 'th'. De Griekse spelling is sympathiek.", "2": "Fout: je schrijft 'y', niet 'i'. En je hebt 'th' nodig: sympathiek.", "3": "Fout: je schrijft 'th', niet 'ht'. De juiste spelling is sympathiek." } }
    }
  ]
}
